import { ITypography } from "../types";

export const typography: ITypography = {
    "heading-6x-large-regular": {
        fontWeight: "400",
        fontSize: "8",
        letterSpacing: "-0.04375",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "8.25"
    },
    "heading-6x-large-medium": {
        fontWeight: "500",
        fontSize: "8",
        letterSpacing: "-0.04375",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "8.25"
    },
    "heading-6x-large-semibold": {
        fontWeight: "600",
        fontSize: "8",
        letterSpacing: "-0.04375",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "8.25"
    },
    "heading-6x-large-bold": {
        fontWeight: "700",
        fontSize: "8",
        letterSpacing: "-0.04375",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "8.25"
    },
    "heading-5x-large-regular": {
        fontWeight: "400",
        fontSize: "6",
        letterSpacing: "-0.0416666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "6.25"
    },
    "heading-5x-large-medium": {
        fontWeight: "500",
        fontSize: "6",
        letterSpacing: "-0.0416666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "6.25"
    },
    "heading-5x-large-semibold": {
        fontWeight: "600",
        fontSize: "6",
        letterSpacing: "-0.0416666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "6.25"
    },
    "heading-5x-large-bold": {
        fontWeight: "700",
        fontSize: "6",
        letterSpacing: "-0.0416666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "6.25"
    },
    "heading-4x-large-regular": {
        fontWeight: "400",
        fontSize: "4.5",
        letterSpacing: "-0.0388888888888889",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "5"
    },
    "heading-4x-large-medium": {
        fontWeight: "500",
        fontSize: "4.5",
        letterSpacing: "-0.0388888888888889",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "5"
    },
    "heading-4x-large-semibold": {
        fontWeight: "600",
        fontSize: "4.5",
        letterSpacing: "-0.0388888888888889",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "5"
    },
    "heading-4x-large-bold": {
        fontWeight: "700",
        fontSize: "4.5",
        letterSpacing: "-0.0388888888888889",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "5"
    },
    "heading-3x-large-regular": {
        fontWeight: "400",
        fontSize: "3.5",
        letterSpacing: "-0.0357142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.75"
    },
    "heading-3x-large-medium": {
        fontWeight: "500",
        fontSize: "3.5",
        letterSpacing: "-0.0357142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.75"
    },
    "heading-3x-large-semibold": {
        fontWeight: "600",
        fontSize: "3.5",
        letterSpacing: "-0.0357142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.75"
    },
    "heading-3x-large-bold": {
        fontWeight: "700",
        fontSize: "3.5",
        letterSpacing: "-0.0357142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.75"
    },
    "heading-xx-large-regular": {
        fontWeight: "400",
        fontSize: "3",
        letterSpacing: "-0.0333333333333333",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.25"
    },
    "heading-xx-large-medium": {
        fontWeight: "500",
        fontSize: "3",
        letterSpacing: "-0.0333333333333333",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.25"
    },
    "heading-xx-large-semibold": {
        fontWeight: "600",
        fontSize: "3",
        letterSpacing: "-0.0333333333333333",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.25"
    },
    "heading-xx-large-bold": {
        fontWeight: "700",
        fontSize: "3",
        letterSpacing: "-0.0333333333333333",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3.25"
    },
    "heading-x-large-regular": {
        fontWeight: "400",
        fontSize: "2.75",
        letterSpacing: "-0.0318181818181818",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3"
    },
    "heading-x-large-medium": {
        fontWeight: "500",
        fontSize: "2.75",
        letterSpacing: "-0.0318181818181818",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3"
    },
    "heading-x-large-semibold": {
        fontWeight: "600",
        fontSize: "2.75",
        letterSpacing: "-0.0318181818181818",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3"
    },
    "heading-x-large-bold": {
        fontWeight: "700",
        fontSize: "2.75",
        letterSpacing: "-0.0318181818181818",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "3"
    },
    "heading-large-regular": {
        fontWeight: "400",
        fontSize: "2.5",
        letterSpacing: "-0.03",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.75"
    },
    "heading-large-medium": {
        fontWeight: "500",
        fontSize: "2.5",
        letterSpacing: "-0.03",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.75"
    },
    "heading-large-semibold": {
        fontWeight: "600",
        fontSize: "2.5",
        letterSpacing: "-0.03",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.75"
    },
    "heading-large-bold": {
        fontWeight: "700",
        fontSize: "2.5",
        letterSpacing: "-0.03",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.75"
    },
    "heading-medium-regular": {
        fontWeight: "400",
        fontSize: "2.25",
        letterSpacing: "-0.0277777777777778",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.5"
    },
    "heading-medium-medium": {
        fontWeight: "500",
        fontSize: "2.25",
        letterSpacing: "-0.0277777777777778",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.5"
    },
    "heading-medium-semibold": {
        fontWeight: "600",
        fontSize: "2.25",
        letterSpacing: "-0.0277777777777778",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.5"
    },
    "heading-medium-bold": {
        fontWeight: "700",
        fontSize: "2.25",
        letterSpacing: "-0.0277777777777778",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.5"
    },
    "heading-regular-regular": {
        fontWeight: "400",
        fontSize: "2",
        letterSpacing: "-0.025",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.25"
    },
    "heading-regular-medium": {
        fontWeight: "500",
        fontSize: "2",
        letterSpacing: "-0.025",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.25"
    },
    "heading-regular-semibold": {
        fontWeight: "600",
        fontSize: "2",
        letterSpacing: "-0.025",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.25"
    },
    "heading-regular-bold": {
        fontWeight: "700",
        fontSize: "2",
        letterSpacing: "-0.025",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2.25"
    },
    "heading-small-regular": {
        fontWeight: "400",
        fontSize: "1.75",
        letterSpacing: "-0.021428571428571",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "heading-small-medium": {
        fontWeight: "500",
        fontSize: "1.75",
        letterSpacing: "-0.021428571428571",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "heading-small-semibold": {
        fontWeight: "600",
        fontSize: "1.75",
        letterSpacing: "-0.021428571428571",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "heading-small-bold": {
        fontWeight: "700",
        fontSize: "1.75",
        letterSpacing: "-0.021428571428571",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "heading-x-small-regular": {
        fontWeight: "400",
        fontSize: "1.5",
        letterSpacing: "-0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "heading-x-small-medium": {
        fontWeight: "500",
        fontSize: "1.5",
        letterSpacing: "-0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "heading-x-small-semibold": {
        fontWeight: "600",
        fontSize: "1.5",
        letterSpacing: "-0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "heading-x-small-bold": {
        fontWeight: "700",
        fontSize: "1.5",
        letterSpacing: "-0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "label-large-regular": {
        fontWeight: "400",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-large-medium": {
        fontWeight: "500",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-large-semibold": {
        fontWeight: "600",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-large-bold": {
        fontWeight: "700",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-medium-regular": {
        fontWeight: "400",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-medium-medium": {
        fontWeight: "500",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-medium-semibold": {
        fontWeight: "600",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-medium-bold": {
        fontWeight: "700",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "label-regular-regular": {
        fontWeight: "400",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-regular-medium": {
        fontWeight: "500",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-regular-semibold": {
        fontWeight: "600",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-regular-bold": {
        fontWeight: "700",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-small-regular": {
        fontWeight: "400",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-small-medium": {
        fontWeight: "500",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-small-semibold": {
        fontWeight: "600",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-small-bold": {
        fontWeight: "700",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "label-x-small-regular": {
        fontWeight: "400",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1"
    },
    "label-x-small-medium": {
        fontWeight: "500",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1"
    },
    "label-x-small-semibold": {
        fontWeight: "600",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1"
    },
    "label-x-small-bold": {
        fontWeight: "700",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1"
    },
    "paragraph-large-regular": {
        fontWeight: "400",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "paragraph-large-medium": {
        fontWeight: "500",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "paragraph-large-semibold": {
        fontWeight: "600",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "paragraph-large-bold": {
        fontWeight: "700",
        fontSize: "1.25",
        letterSpacing: "-0.01",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "2"
    },
    "paragraph-medium-regular": {
        fontWeight: "400",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "paragraph-medium-medium": {
        fontWeight: "500",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "paragraph-medium-semibold": {
        fontWeight: "600",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "paragraph-medium-bold": {
        fontWeight: "700",
        fontSize: "1.125",
        letterSpacing: "-0.005555555555556",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.75"
    },
    "paragraph-regular-regular": {
        fontWeight: "400",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "paragraph-regular-medium": {
        fontWeight: "500",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "paragraph-regular-semibold": {
        fontWeight: "600",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "paragraph-regular-bold": {
        fontWeight: "700",
        fontSize: "1",
        letterSpacing: "0",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.5"
    },
    "paragraph-small-regular": {
        fontWeight: "400",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-small-medium": {
        fontWeight: "500",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-small-semibold": {
        fontWeight: "600",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-small-bold": {
        fontWeight: "700",
        fontSize: "0.875",
        letterSpacing: "0.007142857142857",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-x-small-regular": {
        fontWeight: "400",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-x-small-medium": {
        fontWeight: "500",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-x-small-semibold": {
        fontWeight: "600",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    },
    "paragraph-x-small-bold": {
        fontWeight: "700",
        fontSize: "0.75",
        letterSpacing: "0.016666666666667",
        paragraphSpacing: "0",
        textCase: "none",
        textDecoration: "none",
        lineHeight: "1.25"
    }
};
